import React from "react";
import { adjustFormat } from "util/DateTime";
const DateTimeCell = ({ dateTime }) => {
  const formatDateTime = (dateTimeToFormat) => adjustFormat(dateTimeToFormat, "date");
  return /* @__PURE__ */ React.createElement("p", null, formatDateTime(dateTime));
};
export default DateTimeCell;
